// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: 4EqWEXO89E7
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SelectState from "../../SelectState"; // plasmic-import: EbL1EK3L-GE/component
import SelectBizClass from "../../SelectBizClass"; // plasmic-import: vWhk9cqiwZ0/component
import ContinueButton from "../../ContinueButton"; // plasmic-import: COGC0l6Auj/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingSoleProprietorDetails.module.css"; // plasmic-import: 4EqWEXO89E7/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingSoleProprietorDetails__VariantProps = new Array();

export const PlasmicOnboardingSoleProprietorDetails__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingSoleProprietorDetails__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "selectIndustry.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectState.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "driverState.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__kAdLz)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__sMHa3
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__qchSw)}>
            <div className={classNames(projectcss.all, sty.freeBox__cear5)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg___9Qv8U)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___3LPGh)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__dd3Ni)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__gMgnc)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__zdTyU)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__hwFNj)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__cbmF2)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox___4TF0I)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__vMhHc
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ayXgu
                )}
              >
                {"Personal Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__kxk1Y
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__qhJtI
                )}
              >
                {"Review & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__rr0Tw)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__jaOi
                )}
              >
                {
                  "Astrius collects this information to meet the requirements of our regulators and financial partners."
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__oezTp)}>
                <div className={classNames(projectcss.all, sty.freeBox__cuBbm)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___5MuMc
                    )}
                  >
                    {"First Name"}
                  </div>
                  <input
                    data-plasmic-name={"firstName"}
                    data-plasmic-override={overrides.firstName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.firstName
                    )}
                    placeholder={"First"}
                    ref={ref => {
                      $refs["firstName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__hPkfi)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__dzpZ8
                    )}
                  >
                    {"Last Name"}
                  </div>
                  <input
                    data-plasmic-name={"lastName"}
                    data-plasmic-override={overrides.lastName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.lastName
                    )}
                    placeholder={"Last"}
                    ref={ref => {
                      $refs["lastName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />

                  <div
                    data-plasmic-name={"lastNameError"}
                    data-plasmic-override={overrides.lastNameError}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.lastNameError
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "small") ? (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Must complete all required fields"}
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Lirst Name is required field"}
                        </span>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"firstNameError"}
                data-plasmic-override={overrides.firstNameError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.firstNameError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"First Name is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__dbxHr)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mhWTn
                  )}
                >
                  {"Legal Business Name"}
                </div>
                <input
                  data-plasmic-name={"legalBusinessName"}
                  data-plasmic-override={overrides.legalBusinessName}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.legalBusinessName
                  )}
                  placeholder={"Company"}
                  ref={ref => {
                    $refs["legalBusinessName"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"legalBusinessNameError"}
                  data-plasmic-override={overrides.legalBusinessNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.legalBusinessNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Legal Business Name is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__q9JuL)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__kMLgH
                  )}
                >
                  {"Display Business Name"}
                </div>
                <input
                  data-plasmic-name={"displayBusinessName"}
                  data-plasmic-override={overrides.displayBusinessName}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.displayBusinessName
                  )}
                  placeholder={"Company"}
                  ref={ref => {
                    $refs["displayBusinessName"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"displayBusinessNameError"}
                  data-plasmic-override={overrides.displayBusinessNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.displayBusinessNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Display Business Name is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__wd3K0)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__rfVky
                  )}
                >
                  {"Business Address"}
                </div>
                <input
                  data-plasmic-name={"textInput"}
                  data-plasmic-override={
                    overrides.textInput ?? overrides.textbox
                  }
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.textInput
                  )}
                  placeholder={"12-3456789"}
                  size={1}
                  type={"text"}
                  value={"United States"}
                />

                <input
                  data-plasmic-name={"address1"}
                  data-plasmic-override={overrides.address1}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.address1
                  )}
                  placeholder={"Address Line"}
                  ref={ref => {
                    $refs["address1"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"addressError"}
                  data-plasmic-override={overrides.addressError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.addressError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Address is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <input
                  data-plasmic-name={"city"}
                  data-plasmic-override={overrides.city}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.city
                  )}
                  placeholder={"City"}
                  ref={ref => {
                    $refs["city"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"cityError"}
                  data-plasmic-override={overrides.cityError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.cityError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"City is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <SelectState
                  data-plasmic-name={"selectState"}
                  data-plasmic-override={overrides.selectState}
                  className={classNames("__wab_instance", sty.selectState)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "selectState",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  placeholder={"State"}
                  value={p.generateStateValueProp($state, [
                    "selectState",
                    "value"
                  ])}
                />

                <div
                  data-plasmic-name={"stateError"}
                  data-plasmic-override={overrides.stateError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.stateError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"State is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <input
                  data-plasmic-name={"zip"}
                  data-plasmic-override={overrides.zip}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.zip
                  )}
                  placeholder={"ZIP"}
                  ref={ref => {
                    $refs["zip"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"zipError"}
                  data-plasmic-override={overrides.zipError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.zipError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Zip Code is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__uOU)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__k1F
                  )}
                >
                  {"Date of Birth"}
                </div>
                <div
                  data-plasmic-name={"dob"}
                  data-plasmic-override={overrides.dob}
                  className={classNames(projectcss.all, sty.dob)}
                />

                <div
                  data-plasmic-name={"dobError"}
                  data-plasmic-override={overrides.dobError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.dobError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Date of Birth is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__dq2S9)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___5LvH
                  )}
                >
                  {"Industry"}
                </div>
              </div>
              <SelectBizClass
                data-plasmic-name={"selectIndustry"}
                data-plasmic-override={overrides.selectIndustry}
                className={classNames("__wab_instance", sty.selectIndustry)}
                onChange={(...eventArgs) => {
                  p.generateStateOnChangeProp($state, [
                    "selectIndustry",
                    "value"
                  ])(eventArgs[0]);
                }}
                value={p.generateStateValueProp($state, [
                  "selectIndustry",
                  "value"
                ])}
              />

              <div
                data-plasmic-name={"industryError"}
                data-plasmic-override={overrides.industryError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.industryError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Industry is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___4Piqu)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__qsGEv
                  )}
                >
                  {"Phone Number"}
                </div>
                <input
                  data-plasmic-name={"phoneNumber"}
                  data-plasmic-override={overrides.phoneNumber}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.phoneNumber
                  )}
                  placeholder={""}
                  ref={ref => {
                    $refs["phoneNumber"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"phoneError"}
                  data-plasmic-override={overrides.phoneError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.phoneError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Phone Number is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__cayb9)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__da2Hf
                  )}
                >
                  {"Social Security Number"}
                </div>
                <input
                  data-plasmic-name={"ssn"}
                  data-plasmic-override={overrides.ssn}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.ssn
                  )}
                  placeholder={"123-45-6789"}
                  ref={ref => {
                    $refs["ssn"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"ssnError"}
                  data-plasmic-override={overrides.ssnError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.ssnError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Social Security Number is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__mGlk)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___01MBe
                  )}
                >
                  {"Drivers License Number"}
                </div>
                <input
                  data-plasmic-name={"driversLicense"}
                  data-plasmic-override={overrides.driversLicense}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.driversLicense
                  )}
                  placeholder={""}
                  ref={ref => {
                    $refs["driversLicense"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div className={classNames(projectcss.all, sty.freeBox__yxb9N)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__svaZ
                    )}
                  >
                    {"Drivers License State"}
                  </div>
                  <SelectState
                    data-plasmic-name={"driverState"}
                    data-plasmic-override={overrides.driverState}
                    className={classNames("__wab_instance", sty.driverState)}
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "driverState",
                        "value"
                      ])(eventArgs[0]);
                    }}
                    placeholder={"State"}
                    value={p.generateStateValueProp($state, [
                      "driverState",
                      "value"
                    ])}
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__wegOn)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__x8FrR
                  )}
                >
                  {"Monthly credit card processing volume"}
                </div>
                <div
                  data-plasmic-name={"monthlyVolume"}
                  data-plasmic-override={overrides.monthlyVolume}
                  className={classNames(projectcss.all, sty.monthlyVolume)}
                />

                <div
                  data-plasmic-name={"volumeError"}
                  data-plasmic-override={overrides.volumeError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.volumeError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Processing Volume is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__uAm9D)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__y4L7D
                    )}
                  >
                    {"Average transaction size for credit card payments"}
                  </div>
                  <div
                    data-plasmic-name={"averageTicket"}
                    data-plasmic-override={overrides.averageTicket}
                    className={classNames(projectcss.all, sty.averageTicket)}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"averageError"}
                data-plasmic-override={overrides.averageError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.averageError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Average Transaction is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__hDAig)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__fpZXr
                  )}
                >
                  {
                    "Highest estimated transaction size for credit card payments"
                  }
                </div>
                <div
                  data-plasmic-name={"highestTicket"}
                  data-plasmic-override={overrides.highestTicket}
                  className={classNames(projectcss.all, sty.highestTicket)}
                />

                <div
                  data-plasmic-name={"highestEstimationError"}
                  data-plasmic-override={overrides.highestEstimationError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.highestEstimationError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Highest Estimation Transaction is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div
                data-plasmic-name={"ssnlengtherror"}
                data-plasmic-override={overrides.ssnlengtherror}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.ssnlengtherror
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {
                        "Must provide all 9 digits of the social security number"
                      }
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"ageError"}
                data-plasmic-override={overrides.ageError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.ageError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"You must be at least 18 years old to use our product"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <ContinueButton
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames("__wab_instance", sty.continueButton)}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "firstName",
    "lastName",
    "lastNameError",
    "firstNameError",
    "legalBusinessName",
    "legalBusinessNameError",
    "displayBusinessName",
    "displayBusinessNameError",
    "textInput",
    "textbox",
    "address1",
    "addressError",
    "city",
    "cityError",
    "selectState",
    "stateError",
    "zip",
    "zipError",
    "dob",
    "dobError",
    "selectIndustry",
    "industryError",
    "phoneNumber",
    "phoneError",
    "ssn",
    "ssnError",
    "driversLicense",
    "driverState",
    "monthlyVolume",
    "volumeError",
    "averageTicket",
    "averageError",
    "highestTicket",
    "highestEstimationError",
    "ssnlengtherror",
    "ageError",
    "errorText",
    "continueButton"
  ],

  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle4"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  firstName: ["firstName"],
  lastName: ["lastName"],
  lastNameError: ["lastNameError"],
  firstNameError: ["firstNameError"],
  legalBusinessName: ["legalBusinessName"],
  legalBusinessNameError: ["legalBusinessNameError"],
  displayBusinessName: ["displayBusinessName"],
  displayBusinessNameError: ["displayBusinessNameError"],
  textInput: ["textInput", "textbox"],
  address1: ["address1"],
  addressError: ["addressError"],
  city: ["city"],
  cityError: ["cityError"],
  selectState: ["selectState"],
  stateError: ["stateError"],
  zip: ["zip"],
  zipError: ["zipError"],
  dob: ["dob"],
  dobError: ["dobError"],
  selectIndustry: ["selectIndustry"],
  industryError: ["industryError"],
  phoneNumber: ["phoneNumber"],
  phoneError: ["phoneError"],
  ssn: ["ssn"],
  ssnError: ["ssnError"],
  driversLicense: ["driversLicense"],
  driverState: ["driverState"],
  monthlyVolume: ["monthlyVolume"],
  volumeError: ["volumeError"],
  averageTicket: ["averageTicket"],
  averageError: ["averageError"],
  highestTicket: ["highestTicket"],
  highestEstimationError: ["highestEstimationError"],
  ssnlengtherror: ["ssnlengtherror"],
  ageError: ["ageError"],
  errorText: ["errorText"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicOnboardingSoleProprietorDetails__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingSoleProprietorDetails__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingSoleProprietorDetails__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingSoleProprietorDetails";
  } else {
    func.displayName = `PlasmicOnboardingSoleProprietorDetails.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingSoleProprietorDetails = Object.assign(
  // Top-level PlasmicOnboardingSoleProprietorDetails renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    firstName: makeNodeComponent("firstName"),
    lastName: makeNodeComponent("lastName"),
    lastNameError: makeNodeComponent("lastNameError"),
    firstNameError: makeNodeComponent("firstNameError"),
    legalBusinessName: makeNodeComponent("legalBusinessName"),
    legalBusinessNameError: makeNodeComponent("legalBusinessNameError"),
    displayBusinessName: makeNodeComponent("displayBusinessName"),
    displayBusinessNameError: makeNodeComponent("displayBusinessNameError"),
    textInput: makeNodeComponent("textInput"),
    address1: makeNodeComponent("address1"),
    addressError: makeNodeComponent("addressError"),
    city: makeNodeComponent("city"),
    cityError: makeNodeComponent("cityError"),
    selectState: makeNodeComponent("selectState"),
    stateError: makeNodeComponent("stateError"),
    zip: makeNodeComponent("zip"),
    zipError: makeNodeComponent("zipError"),
    dob: makeNodeComponent("dob"),
    dobError: makeNodeComponent("dobError"),
    selectIndustry: makeNodeComponent("selectIndustry"),
    industryError: makeNodeComponent("industryError"),
    phoneNumber: makeNodeComponent("phoneNumber"),
    phoneError: makeNodeComponent("phoneError"),
    ssn: makeNodeComponent("ssn"),
    ssnError: makeNodeComponent("ssnError"),
    driversLicense: makeNodeComponent("driversLicense"),
    driverState: makeNodeComponent("driverState"),
    monthlyVolume: makeNodeComponent("monthlyVolume"),
    volumeError: makeNodeComponent("volumeError"),
    averageTicket: makeNodeComponent("averageTicket"),
    averageError: makeNodeComponent("averageError"),
    highestTicket: makeNodeComponent("highestTicket"),
    highestEstimationError: makeNodeComponent("highestEstimationError"),
    ssnlengtherror: makeNodeComponent("ssnlengtherror"),
    ageError: makeNodeComponent("ageError"),
    errorText: makeNodeComponent("errorText"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicOnboardingSoleProprietorDetails
    internalVariantProps: PlasmicOnboardingSoleProprietorDetails__VariantProps,
    internalArgProps: PlasmicOnboardingSoleProprietorDetails__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingSoleProprietorDetails;
/* prettier-ignore-end */
